// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".003074e31d42e6d2d2f6d1b04b770f6bb7c0abd3.chunk.js";
};